import type { FC } from 'react';
import { useTheme } from 'styled-components/macro';

import type { IconPropsT } from './Icon';
import Icon from './Icon';

const SendIcon: FC<IconPropsT> = props => {
  /**
   * Hooks
   */
  const theme = useTheme();

  return (
    <Icon {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill={theme.colors.primary.variant1}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M17.865 0.839976C17.8159 0.791062 17.7541 0.756754 17.6865 0.740865C17.619 0.724976 17.5484 0.72813 17.4825 0.749976L0.232549 7.87497C0.159133 7.90488 0.0970829 7.95729 0.0553102 8.02466C0.0135375 8.09204 -0.00580901 8.17092 4.89629e-05 8.24997C0.00200484 8.32463 0.0257731 8.39708 0.0684215 8.45839C0.11107 8.5197 0.170733 8.56718 0.240049 8.59497L4.98755 10.4325C5.04509 10.4545 5.10703 10.4626 5.16831 10.4561C5.22958 10.4496 5.28843 10.4286 5.34005 10.395L11.64 5.89498C11.7166 5.83132 11.8154 5.8007 11.9145 5.80984C12.0137 5.81898 12.1051 5.86714 12.1688 5.94373C12.2325 6.02031 12.2631 6.11904 12.2539 6.2182C12.2448 6.31736 12.1966 6.40882 12.12 6.47248L6.87005 11.535C6.79826 11.6065 6.7578 11.7036 6.75755 11.805V16.875C6.75672 16.9574 6.78364 17.0377 6.83397 17.103C6.8843 17.1683 6.95512 17.2148 7.03505 17.235C7.11426 17.2574 7.19872 17.2526 7.27488 17.2213C7.35103 17.1901 7.41448 17.1341 7.45505 17.0625L9.83255 12.9975C9.85629 12.9556 9.89522 12.9244 9.9413 12.9105C9.98738 12.8965 10.0371 12.9008 10.08 12.9225L14.4525 15.33C14.5036 15.3582 14.5606 15.3741 14.6188 15.3764C14.6771 15.3787 14.7352 15.3675 14.7883 15.3434C14.8415 15.3194 14.8883 15.2833 14.925 15.238C14.9618 15.1927 14.9875 15.1394 15 15.0825L18 1.20748C18.0136 1.13973 18.0081 1.06956 17.9843 1.00471C17.9605 0.93986 17.9192 0.882852 17.865 0.839976Z" />
      </svg>
    </Icon>
  );
};

export default SendIcon;
